import { Tabs } from "@mui/material";
import styled from "styled-components";

export const TabsStyle = styled(Tabs)`
  min-height: 40px !important;
  background: #f5f7fa;
  & .MuiTabs-flexContainer {
    min-height: 40px;
    flex-wrap: wrap;
    /* background: rgb(238 242 255 / var(--tw-bg-opacity, 1)); */

    border: 1px solid #d6d4e1;
    position: relative;
    z-index: 10;
  }
  .MuiButtonBase-root {
    min-height: 40px;
    position: relative;
    text-transform: inherit;
    /* border-right: 1px solid #d6d4e1;
    border-top: 1px solid #d6d4e1;
    border-bottom: 1px solid #d6d4e1;
    border-left: 1px solid #d6d4e1; */
    color: #000;
    font-size: 0.8rem;
    padding: 12px 12px;
    &:before {
      position: absolute;
      content: "";
      width: 1px;
      height: 13px;
      background: #000;
      right: 0;
    }
    &:first-child {
      border-left: 1px solid #d6d4e1;
    }
    svg {
      margin-bottom: 10px;
    }
  }
  .Mui-selected {
    color: #fff !important;
    background: #5d68bd;
  }
  .MuiTabs-indicator {
    z-index: 1;
    background: #5d68bd;
    display: none;
  }
`;

export const TanContent = styled(Tabs)`
  .MuiBox-root {
    padding: 0;
    width: 100%;
  }
`;
